import React, { Fragment, useState } from 'react';
import { GridColumn } from '@atlaskit/page';
import { TextField } from '../../../components/FormFields';
import Button, { ButtonGroup } from '@atlaskit/button';
import { FormFooter } from '@atlaskit/form';
import i18n from 'i18next';
import { Trans } from 'react-i18next';

const CommentForm = ({ comments, onCommentSubmit, fetching }) => {
  const [text, setText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const commentsPerPage = 5; 

  const handleTextChange = (name, value) => {
    if (name && name === "comment")
        setText(value || '');
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (text.trim()) {
      onCommentSubmit({ text, userId: 1, createdAt: new Date().toISOString() });
      setText(''); 
    }
  };

  const indexOfLastComment = currentPage * commentsPerPage;
  const indexOfFirstComment = indexOfLastComment - commentsPerPage;
  const currentComments = comments.slice(indexOfFirstComment, indexOfLastComment);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <Fragment>
      <form onSubmit={handleSubmit}>
        <GridColumn medium={12}>
          <TextField
            name="comment"
            label={i18n.t('fota:Add a comment')}
            placeholder={i18n.t('fota:Enter a comment')}
            required={true}
            onChange={handleTextChange}
            isDisabled={fetching}
            value={text}
          />
        </GridColumn>
        <GridColumn medium={12}>
          <FormFooter>
            <ButtonGroup>
              <Button
                type="submit"
                isDisabled={fetching || !text.trim()}
                isLoading={fetching}
                appearance="primary"
              >
                <Trans>Add</Trans>
              </Button>
            </ButtonGroup>
          </FormFooter>
        </GridColumn>
      </form>

      <GridColumn medium={12}>
        {comments && comments.length > 0 ? (
          <Fragment>
            {currentComments.map((comment, index) => (
              <div key={index}>
                <div>{comment.userName}</div>
                <div style={{ fontSize: '11px', color: '#999' }}>
                  {new Date(comment.createdAt).toLocaleString()}
                </div>
                <p>{comment.text}</p>
                <hr />
              </div>
            ))}

            <div style={{ marginTop: '10px',  textAlign: 'center' }}>
              {Array.from({ length: Math.ceil(comments.length / commentsPerPage) }, (_, i) => (
                <Button
                  key={i}
                  onClick={() => paginate(i + 1)}
                  appearance={currentPage === i + 1 ? 'primary' : 'subtle'}
                  style={{ margin: '0 5px'}}
                >
                  {i + 1}
                </Button>
              ))}
            </div>
          </Fragment>
        ) : (
          <p>{i18n.t('fota:No comments yet')}</p>
        )}
      </GridColumn>
    </Fragment>
  );
};

export default CommentForm;
